module.exports = __webpack_public_path__ + "img/network-broadband.99a39e8.svg";